import clsx from 'clsx';
import { memo } from 'react';
import SingleSpaParcel, { ParcelCompProps } from 'single-spa-react/parcel';

/**
 * A wrapper component wor SingleSpaParcel that allows for additional styling and className management.
 *
 * It allows to use both `className` and `wrapClassName` props to apply custom styles. It is required
 * as @emotin/styled always maps the generated className to the `className` prop of the `SingleSpaParcel`
 * component, but `SingleSpaParcel` uses `wrapClassName` prop to apply styles to the wrapping element.
 */
const Parcel = memo(({ className, wrapClassName, ...props }: ParcelCompProps) => (
  <SingleSpaParcel wrapClassName={clsx(className, wrapClassName)} {...props} />
));

export default Parcel;
